import { createProfessionalExporter } from '../../../utils/professionalExport';
import { formatCurrency } from './trainerData';

const headers = ['Trainer', 'Specialization', 'Branch', 'Phone', 'Salary', 'Members', 'Status'];

function formatStatus(status) {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

const exporter = createProfessionalExporter({
  title: 'Trainer List',
  headers,
  slug: 'trainers',
  getRows: (list) =>
    list.map((t) => [
      t.name,
      t.specialization,
      t.branch,
      t.phone,
      formatCurrency(t.salary),
      (t.assignedMembers || []).length,
      formatStatus(t.status),
    ]),
  getSummary: (list) => [
    `Total trainers: ${list.length}`,
    `Active: ${list.filter((t) => t.status === 'active').length}`,
  ],
});

export const printTrainerList = (data) => exporter.print(data);
export const exportTrainerCsv = (data) => exporter.csv(data);
export const exportTrainerExcel = (data) => exporter.excel(data);
export const exportTrainerPdf = (data) => exporter.pdf(data);
export const exportTrainers = (data) => exporter.export(data);
